import { useAuth } from "@/hooks/useAuth";
import { $api } from "@/lib/api";
import { keepPreviousData } from "@tanstack/react-query";

/**
 * Cached precedents query that reads from TanStack Query cache.
 *
 * When search is empty the hook uses the same cache key as the prefetch
 * in useDashboardPrefetch / route loader, giving instant renders on tab switch.
 */
export function usePrecedentsQuery(search?: string) {
  const { backendToken } = useAuth();

  // When searching, pass params so results are cached per-query.
  // When not searching, pass undefined to match the bare prefetch key.
  return $api.useQuery(
    "get",
    "/api/v1/precedents",
    search ? { params: { query: { search } } } : undefined,
    {
      staleTime: 5 * 60 * 1000,
      placeholderData: keepPreviousData,
      enabled: !!backendToken,
      // Poll every 20s while any item is still being analyzed, then stop
      refetchInterval: (query) => {
        const data = query.state.data;
        if (!data) return false;
        const hasUnanalyzed = data.some(
          (p) => p.heading_hierarchy == null,
        );
        return hasUnanalyzed ? 20_000 : false;
      },
    },
  );
}
